module.exports = __webpack_public_path__ + "images/office365.6e99ac7e.png";